import { UrlSerializer, UrlTree, DefaultUrlSerializer } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable()
export class XUrlSerializerService extends DefaultUrlSerializer implements UrlSerializer {
    constructor() {
        super();
    }

    override parse(url: any): UrlTree {
        url = url.replace(/\/;/, ';');
        return super.parse(url);
    }

    override serialize(tree: UrlTree): any {
        let path = super.serialize(tree);
        path = path.replace(/(\d|\w);/, '$1/;');

        let hashArr = path.split('#');
        path = hashArr[0];
        let pathArr = path.split('?');
        pathArr[0] = pathArr[0].replace(/\/$/img, '') + '/'
        let joinSeparator = pathArr.length > 1 ? "?" : "";
        path = pathArr.join(joinSeparator);
        if (hashArr[1]) {
            hashArr[1] = hashArr[1].replace(/\/$/img, '');
            path = ([path, hashArr[1]]).join('#');
        } else if ('locationHash' in window) {
            path = path + window.locationHash;
        }
        return path;
    }
}
